"use client"

import { useOurContext } from "@/context/dot-field.context"

import styles from "./dot-field.module.css"
import { DotRow } from "./dot-row/dot-row"

let dotRows: React.ReactNode[] = []

for (let rowIndex = -55; rowIndex <= 55; rowIndex++) {
  dotRows.push(<DotRow key={rowIndex} rowIndex={rowIndex} />)
}

// Dot field component. Made up of dot rows, which are made up of dots.
export function DotField() {
  const { dotFieldIndex } = useOurContext()
  return (
    <div className={`dotField ${styles["container"]}`} dot-field-index={dotFieldIndex}>
      {dotRows}
    </div>
  )
}
